import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const baseQueryAnalytics = ({
  baseUrl = '',
}: {
  baseUrl?: string;
} = {}) =>
  fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as any)?.analytics?.token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
    fetchFn: async (...args) => {
      const response = await fetch(...args);

      if ([403, 401].includes(response.status)) {
        console.error('Auth error', response);
      }

      if (response.status >= 404) {
        console.log('WINDOW POST MESSAGE');
        window.postMessage(
          {
            type: 'demostackDataInternalError',
            response: {
              url: response.url,
              status: response.status,
            },
          },
          '*'
        );
        console.error('Internal error', response);
      }

      return response;
    },
  });
